module.exports = __webpack_public_path__ + "static/media/notepad.598a9568.png";